import { timestampAddData } from "../cloud/firebase/firestore/document";
import { Collection, Where, OrderBy } from "../cloud/firebase/firestore/collection";
import { CallData, CallState, makeCallState } from "./call-state";
import { Call } from "./call";

function makeCollectionPath(oid: number): string {
  return `orgs/${oid}/calls`;
}

/**
 * Calls class.
 */
export class Calls extends Collection<Call, CallState> {
  /**
   * Adds a Call.
   * @param oid Organization Id.
   * @param data Call data.
   */
  static add(oid: number, data: CallData): Promise<string> {
    return this.addDocument(makeCollectionPath(oid), timestampAddData(data));
  }

  /**
   * Gets Calls
   * @param oid Organization Id.
   * @param where Where constraints.
   * @param orderBy OrderBy constraints.
   * @param limit Limit contraint.
   */
  static get(
    oid: number,
    where?: Array<Where>,
    orderBy?: Array<OrderBy>,
    limit?: number
  ): Promise<Array<CallState>> {
    return this.getCollection(makeCallState, makeCollectionPath(oid), where, orderBy, limit);
  }

  /** Constructor. */
  constructor() {
    super(Call);
  }

  /** Disposes. */
  dispose() {
    super.dispose();
  }

  /**
   * Starts listening for updates to Calls.
   * @param oid Organization Id.
   * @param where Where constraints.
   * @param orderBy OrderBy constraints.
   * @param limit Limit contraint.
   */
  start(oid: number, where?: Array<Where>, orderBy?: Array<OrderBy>, limit?: number): void {
    return this.startListening(makeCallState, makeCollectionPath(oid), where, orderBy, limit);
  }

  /**
   * Stops listening.
   */
  stop(): void {
    this.stopListening();
  }
}
